"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var Stamp_1 = require("./Stamp");
var AcStampButton_1 = require("./AcStampButton");
var AcPdfEditorSideMenu_1 = require("../AcPdfEditorSideMenu");
exports.AcTextboxButton = function () {
    var setActiveMenu = react_1.useContext(AcPdfEditorSideMenu_1.AcPdfEditorSideMenuContext).setActiveMenu;
    var getStamp = function () {
        return Stamp_1.Stamp.textboxStamp();
    };
    var dropdownProps = {
        id: 'faxTextboxButtonDropdown',
        title: react_1.default.createElement("i", { className: "far fa-ellipsis-v-alt" }),
        align: 'alignLeft',
        disableDropdownIcon: true,
        size: 'sm',
        actions: [
            {
                name: '定型文から選ぶ',
                icon: 'far fa-text',
                onClick: function () {
                    if (setActiveMenu) {
                        setActiveMenu('phraseMenu');
                    }
                },
            },
        ],
    };
    return (react_1.default.createElement(AcStampButton_1.AcStampButton, { stamp: getStamp(), size: "stamp_md", dropdownProps: dropdownProps, dropdownData: true, label: "\u30C6\u30AD\u30B9\u30C8", width: 50, height: 50 }));
};
exports.AcTextboxButton.displayName = 'AcTextboxButton';
//# sourceMappingURL=AcTextboxButton.js.map